import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	container: {
		maxWidth: 1366
	}
})

export default useStyles
